import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";

class Carousel extends Component {
  constructor(props) {
    super(props);

    let data = localStorage.getItem("userData");
    let name, lander_btc_address;
    if (data) {
      let user = JSON.parse(data);
      lander_btc_address = user.lander_btc_address;
      name = user.name.split("");
    }

    this.cursor = "|";
    this.words = [
      ["D", "o", "n", "a", "t", "i", "n", "g"],
      ["I", "n", "v", "e", "s", "t", "i", "n", "g"]
    ];
    if (name) {
      this.words.unshift(name);
    }

    this.index = 0;
    this.position = 0;
    this.wordState = "";

    this.state = {
      word: "",
      cursor: ""
    };

    setInterval(() => {
      let cursor = "|";

      if (this.state.cursor === "|") {
        cursor = "";
      }

      this.setState(...this.state, {
        cursor: cursor
      });
    }, 700);

    this.startSequence();
  }

  startSequence(idTrack) {
    if (idTrack) {
      clearInterval(idTrack);
    }

    let wordState = "";

    let intervalId = setInterval(() => {
      if (this.words[this.index].length > this.position) {
        wordState += this.words[this.index][this.position];
        this.position++;
      } else if (this.words.length > this.index + 1) {
        this.index++;
        this.position = 0;
        this.restartSequence(intervalId);
      } else {
        this.index = 0;
        this.position = 0;
        this.restartSequence(intervalId);
      }

      this.setState(...this.state, {
        word: wordState
      });
    }, 400);
  }

  restartSequence(idTrack) {
    if (idTrack) {
      clearInterval(idTrack);
    }
    this.context;
    let intervalId = setInterval(() => {
      let word = this.state.word;
      if (word.length > 0) {
        word = word.slice(0, -1);
        this.setState(...this.state, {
          word: word
        });
      } else {
        this.startSequence(intervalId);
      }
    }, 100);
  }

  render() {
    const handleScrollToElement = this.props.handleScrollToElement;

    return (
      <header className="carousel">
        <div className="carousel-overlay">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="carousel-container">
                  <h1 className="carousel-title text-center">
                    Social Investments Disrupted Globally
                  </h1>
                  <h2 className="carousel-subtitle text-center">
                    Have Fun {this.state.word}
                    {this.state.cursor}
                    <br /> Collect Cryptolands!
                  </h2>
                  <img
                    className="d-block m-auto"
                    width="185"
                    alt="sun"
                    src="/assets/images/ms-icon-310x310.png"
                  />
                  <div className="row justify-content-center">
                    <div className="col-lg-4">
                      <a
                        onClick={e => handleScrollToElement(e, "main")}
                        className="btn btn-block btn-cta cta-item text-center"
                      >
                        How it Works
                      </a>
                    </div>
                    <div className="col-lg-4">
                      <Link
                        className="btn btn-block btn-cta cta-item text-center"
                        to="/planets"
                      >
                        Go to Planets
                      </Link>
                    </div>{" "}
                    {/* Go to Planets */}
                    <div className="col-lg-4">
                      <a
                        onClick={e => handleScrollToElement(e, "ngos")}
                        className="btn btn-block btn-cta cta-item text-center"
                      >
                        Causes
                      </a>
                    </div>{" "}
                    {/* Non-Govs */}
                  </div>{" "}
                  {/* 3 Buttons */}
                  <img
                    className="arrow-down"
                    src="assets/images/down.gif"
                    onClick={e => handleScrollToElement(e, "hallOfFame")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/containers/HomePage/carousel.js